
import React, { JSX, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router'
import { OverlayShell } from 'components/OverlayShell'
import { MerchExtUiPreview } from 'components/MerchBoardPanel'
import { MerchBoardView } from 'components/MerchBoardView'
import { OverlayAutoFit } from 'components/OverlayAutoFit'
import { MERCH_TICKER_MARQUEE_WIDTH } from 'components/MerchTickerMarquee'
import { useOverlaySocketCredential } from 'hooks/useOverlaySocketCredential'

const parseExtUi = (raw: string | null): MerchExtUiPreview | undefined => {
  if (raw === 'collapsed') return 'collapsed'
  if (raw === '1' || raw === 'expanded') return 'expanded'
  return undefined
}

export const MerchOverlayBody = ({
  merchOverlayId,
  token
}: {
  merchOverlayId: string
  token: string
}): JSX.Element => {
  const [searchParams] = useSearchParams()
  const extui = parseExtUi(searchParams.get('extui'))

  const [pageBackground, setPageBackground] = useState('transparent')
  const [isTicker, setIsTicker] = useState(false)
  useEffect(() => {
    if (pageBackground === 'transparent') return
    document.body.style.background = pageBackground
    return () => {
      document.body.style.background = 'transparent'
    }
  }, [pageBackground])

  return (
    <OverlayAutoFit
      mode={isTicker
        ? { kind: 'design', width: MERCH_TICKER_MARQUEE_WIDTH }
        : { kind: 'off' }}
    >
      <MerchBoardView
        merchOverlayId={merchOverlayId}
        token={token}
        extui={extui}
        onEnvelope={(envelope) => {
          setIsTicker(envelope.displayStyle === 'ticker')
          setPageBackground(
            envelope.displayStyle === 'ticker'
              ? envelope.tickerStyle.pageBackground
              : 'transparent'
          )
        }}
      />
    </OverlayAutoFit>
  )
}

export const MerchOverlayPage = (): JSX.Element => {
  const { merchOverlayId } = useParams<{ merchOverlayId: string }>()
  const token = useOverlaySocketCredential()

  if (merchOverlayId == null || merchOverlayId === '' || token == null || token === '') {
    return <OverlayShell>{null}</OverlayShell>
  }

  return (
    <OverlayShell>
      <MerchOverlayBody merchOverlayId={merchOverlayId} token={token} />
    </OverlayShell>
  )
}
